/* Library */
import React, { Component } from 'react';

class Inspiration extends Component {
  render() {
    const data = this.props.BannerImageTargeter ? this.props.BannerImageTargeter.data : null;
    return (
      <div id="bannerImage" dangerouslySetInnerHTML={{ __html: data }} />
    );
  }
}

export default Inspiration;
